import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { HashRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import HttpNotifier from './http-notifier'
import Http from './http'
import Notifications from './notifications'
import Messages from './messages'
import MessageTray from './message-tray'
//import Router from './router'


export const Permission = (prms) => {
	return {
		has: (prm) => (prms & prm) === prm,
		view: () => (prms & 1) === 1,
		read: () => (prms & 1) === 1,
		edit: () => (prms & 2) === 2,
		delete: () => (prms & 4) === 4
	}
}

// devolve novo objeto apenas com as primitivas
Object.flat = obj => {
	let data = {};

	Object.keys(obj).forEach(k => {
		if (!(obj[k] instanceof Object)) {
			data[k] = obj[k];
		}
	});
	return data;
}

window.httpNotifier = window.httpNotifier || new HttpNotifier();
window.http = Http;
window.messages = window.messages || new Notifications();
window.notifications = window.notifications || new Notifications(8000);

export const App = props => (
	<>
		<Messages />
		<Provider store={props.store}>
			<HashRouter>{props.children}</HashRouter>
		</Provider>
		<MessageTray />
	</>
)
App.propTypes = {
	store: PropTypes.object.isRequired
}

export const SimpleApp = props => (
	<div>
		<Messages />
		{props.children}
		<MessageTray />
	</div>
)

const renderRoute = (routes, el) => {
	let appelem = null

	if (Array.isArray(el)) {
		for (let e of el) {
			if ((appelem = document.getElementById(e)) != null) {
				break
			}
		}
	}
	else {
		appelem = document.getElementById(el)
	}
	if (appelem) {
		const root = createRoot(appelem)
		if (routes instanceof Function) {
			root.render(routes())
			return true;
		}
		if (routes.hasOwnProperty(hp.store.route)) {
			const route = routes[hp.store.route] instanceof Function
				? routes[hp.store.route]()
				: routes[hp.store.route]
			root.render(route)
			return true
		}
	}
	return false
}

export const startup = (routes, el = 'app') => {
	if (!renderRoute(routes, el)) {
		document.addEventListener("DOMContentLoaded", () => {
			renderRoute(routes, el)
		})
	}
}
